export default __webpack_public_path__ + "static/4w1hog-aa3e12fbc1eb3dea7fb230003ada26fc.webp";